// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetFullBodyProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/prescriptions/web/fullBody", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.web.fullBody.TWISTER_BUDDY.id]: {
      img: protocolImg["./twisterBuddy.png"],
      name: "twisterBuddy",
      video: "twisterBuddyVideo",
      description: "twisterBuddyDescription",
    },
    [protocols.web.fullBody.COSTUME_PARTY.id]: {
      img: protocolImg["./costumeParty.png"],
      name: "costumeParty",
      video: "costumePartyVideo",
      description: "costumePartyDescription",
    },
    [protocols.web.fullBody.GENTLE_GIANT.id]: {
      img: protocolImg["./gentleGiant.png"],
      name: "gentleGiant",
      video: "gentleGiantVideo",
      description: "gentleGiantDescription",
    },
  };

  return protocolsData[Number(protocolId)];
};
